/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'

import { Modal, useModal } from '@cred/react-overlay'

import styles from './styles.module.scss'

const FilterModal = ({ filterText, children, formName }) => {
  const { open, close, isOpen } = useModal({ name: formName })

  return (
    <>
      <div className={`${styles['filter-banner']} ${styles.background}`} onClick={open}>
        <i className={`icon-filter ${styles['filter-icon']}`} />
        <strong className={`${styles.filter} semiBold`}>Filters</strong>
        <span>{filterText}</span>
      </div>
      <Modal isOpen={isOpen} dismissible close={close}>
        <div className={styles.modalContent}>
          <p className={`${styles.header} bodySmall bold`}>Filter</p>
          <section className={styles.container}>{children({ closeModal: close })}</section>
        </div>
      </Modal>
    </>
  )
}

FilterModal.propTypes = {
  filterText: PropTypes.string,
  formName: PropTypes.string,
  children: PropTypes.func,
}

export { FilterModal as FilterModalNoHoc }

export default FilterModal
